import {
  Accessibility,
  ALargeSmallIcon,
  AlertCircle,
  AppWindow,
  ArrowDownIcon,
  ArrowDownUp,
  ArrowLeft,
  ArrowRightIcon,
  ArrowUpIcon,
  ArrowUpRight,
  AtSign,
  BarChart4,
  BaselineIcon,
  Blend,
  Blocks,
  BookMarked,
  Bot,
  Braces,
  Brain,
  CalendarIcon,
  ChartNoAxesGantt,
  CheckCheck,
  CheckCircle2,
  CheckIcon,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronsDownUpIcon,
  ChevronsUpDown,
  ChevronUp,
  CircleAlert,
  CircleArrowRight,
  CircleArrowUp,
  CircleCheck,
  CircleChevronLeft,
  CircleChevronRight,
  CircleDashed,
  CircleDollarSign,
  CircleGauge,
  CircleHelp,
  CircleIcon,
  CirclePlayIcon,
  CirclePlus,
  CircleStop,
  CircleUser,
  CircleX,
  Clock,
  ClockFadingIcon,
  Code,
  Code2,
  CoinsIcon,
  Copy,
  CpuIcon,
  Database,
  Ellipsis,
  EllipsisVertical,
  EqualApproximatelyIcon,
  EqualIcon,
  EqualNotIcon,
  Expand,
  ExternalLink,
  Eye,
  File,
  FileDown,
  FilePlus,
  FileQuestion,
  FileUpIcon,
  FileX2,
  FolderClosed,
  FolderOpen,
  FolderPlus,
  Forward,
  GiftIcon,
  GitCompareArrows,
  GithubIcon,
  GitlabIcon,
  Globe,
  Headset,
  History,
  House,
  Image,
  ImageOff,
  ImageUp,
  Infinity as InfinityIcon,
  InfoIcon,
  LetterText,
  Lightbulb,
  Link2,
  ListCheck,
  ListOrdered,
  ListTodo,
  ListVideo,
  LoaderCircle,
  Lock,
  LogOut,
  Logs,
  Mail,
  MapPin,
  Maximize2,
  MessageCircleIcon,
  Minimize2,
  MinusIcon,
  MonitorIcon,
  Moon,
  MousePointerClick,
  Newspaper,
  Paperclip,
  Pause,
  Pencil,
  PercentIcon,
  Pin,
  PinOff,
  Play,
  PlusIcon,
  Puzzle,
  Radio,
  RectangleHorizontal,
  RefreshCcw,
  RegexIcon,
  Repeat2,
  RocketIcon,
  RotateCcw,
  ScrollTextIcon,
  SearchIcon,
  SendToBack,
  SettingsIcon,
  SigmaIcon,
  SlackIcon,
  Space,
  Sparkles,
  Square,
  SquareArrowRight,
  SquareChartGantt,
  SquareDot,
  SquareMinus,
  SquarePlus,
  Star,
  Sun,
  Terminal,
  Thermometer,
  ThumbsDown,
  ThumbsUp,
  Trash2Icon,
  TwitterIcon,
  Undo,
  Unplug,
  UserRound,
  UsersIcon,
  WholeWord,
  Wrench,
  XIcon,
  YoutubeIcon,
  Zap,
  SquareDashed,
  Brush,
  ShieldAlertIcon,
  FlaskConical,
  EyeOffIcon,
  ChevronsRightIcon,
  TriangleAlert,
  WandSparkles,
  CornerDownRightIcon,
  Type,
  Video,
  Volume2,
  MessageSquareTextIcon,
  Split,
  Coffee,
  UserRoundPlus,
  GraduationCap,
  Bell,
  CreditCardIcon,
  KeyRound,
  MessageCircle,
} from 'lucide-react'
import { MouseEvent } from 'react'

import { cn } from '../../../lib/utils'
import { colors, DarkTextColor, type TextColor } from '../../tokens'
import {
  FilledBadgeCheckIcon,
  GridVertical,
  LatitudeLogo,
  LatitudeLogoMonochrome,
  MCP,
} from './custom-icons'
import AmazonBedrock from './custom-icons/llmProviders/amazoBedrock'
import Anthropic from './custom-icons/llmProviders/anthropic'
import Azure from './custom-icons/llmProviders/azure'
import DeepSeek from './custom-icons/llmProviders/deepSeek'
import GoogleGemini from './custom-icons/llmProviders/googleGemini'
import GoogleVertex from './custom-icons/llmProviders/googleVertex'
import Groq from './custom-icons/llmProviders/groq'
import Mistral from './custom-icons/llmProviders/mistral'
import OpenAI from './custom-icons/llmProviders/openai'
import Perplexity from './custom-icons/llmProviders/perplexity'
import XAI from './custom-icons/llmProviders/xai'
import Airbnb from './custom-icons/logos/Airbnb'
import Airtable from './custom-icons/logos/Airtable'
import Apify from './custom-icons/logos/Apify'
import Attio from './custom-icons/logos/Attio'
import Audiense from './custom-icons/logos/Audiense'
import AwsBedrock from './custom-icons/logos/AwsBedrock'
import Brave from './custom-icons/logos/Brave'
import Browserbase from './custom-icons/logos/Browserbase'
import Discord from './custom-icons/logos/Discord'
import Exa from './custom-icons/logos/Exa'
import Figma from './custom-icons/logos/Figma'
import Ghost from './custom-icons/logos/Ghost'
import Google from './custom-icons/logos/Google'
import Hyperbrowser from './custom-icons/logos/Hyperbrowser'
import Intercom from './custom-icons/logos/Intercom'
import IntercomChat from './custom-icons/logos/IntercomChat'
import Jira from './custom-icons/logos/Jira'
import Linear from './custom-icons/logos/Linear'
import Mintlify from './custom-icons/logos/Mintlify'
import Monday from './custom-icons/logos/Monday'
import Neon from './custom-icons/logos/Neon'
import Notion from './custom-icons/logos/Notion'
import Postgres from './custom-icons/logos/Postgres'
import Readwise from './custom-icons/logos/Readwise'
import Reddit from './custom-icons/logos/Reddit'
import Redis from './custom-icons/logos/Redis'
import Sentry from './custom-icons/logos/Sentry'
import Stripe from './custom-icons/logos/Stripe'
import Supabase from './custom-icons/logos/Supabase'
import Telegram from './custom-icons/logos/Telegram'
import Tinybird from './custom-icons/logos/Tinybird'
import TwitterX from './custom-icons/logos/TwitterX'
import Wordpress from './custom-icons/logos/Wordpress'
import YepCode from './custom-icons/logos/YepCode'

const Icons = {
  shieldAlert: ShieldAlertIcon,
  addCircle: CirclePlus,
  addSquare: SquarePlus,
  squareChart: SquareChartGantt,
  airbnb: Airbnb,
  airtable: Airtable,
  alert: CircleAlert,
  alertCircle: AlertCircle,
  alertTriangle: TriangleAlert,
  apify: Apify,
  appWindow: AppWindow,
  arrowDown: ArrowDownIcon,
  arrowLeft: ArrowLeft,
  arrowRight: ArrowRightIcon,
  arrowUp: ArrowUpIcon,
  arrowUpRight: ArrowUpRight,
  arrowDownUp: ArrowDownUp,
  atSign: AtSign,
  attio: Attio,
  audiense: Audiense,
  audio: Volume2,
  awsBedrock: AwsBedrock,
  barChart4: BarChart4,
  blocks: Blocks,
  bookMarked: BookMarked,
  bot: Bot,
  cpu: CpuIcon,
  bell: Bell,
  braces: Braces,
  brain: Brain,
  brave: Brave,
  browserbase: Browserbase,
  brush: Brush,
  calendar: CalendarIcon,
  chat: MessageCircleIcon,
  messageSquareText: MessageSquareTextIcon,
  check: CheckCircle2,
  checkCheck: CheckCheck,
  checkClean: CheckIcon,
  chevronDown: ChevronDown,
  chevronLeft: ChevronLeft,
  chevronRight: ChevronRight,
  chevronsRight: ChevronsRightIcon,
  chevronUp: ChevronUp,
  chevronsDownUp: ChevronsDownUpIcon,
  chevronsUpDown: ChevronsUpDown,
  circle: CircleIcon,
  circleArrowUp: CircleArrowUp,
  circleArrowRight: CircleArrowRight,
  circleChevronLeft: CircleChevronLeft,
  circleChevronRight: CircleChevronRight,
  circleDollarSign: CircleDollarSign,
  circleHelp: CircleHelp,
  circleStop: CircleStop,
  circleUser: CircleUser,
  circleCheck: CircleCheck,
  circleX: CircleX,
  circleDashed: CircleDashed,
  clipboard: Copy,
  clock: Clock,
  clockFading: ClockFadingIcon,
  close: XIcon,
  code2: Code2,
  code: Code,
  coffee: Coffee,
  database: Database,
  deletion: SquareMinus,
  discord: Discord,
  ellipsis: Ellipsis,
  ellipsisVertical: EllipsisVertical,
  equal: EqualIcon,
  equalApproximately: EqualApproximatelyIcon,
  externalLink: ExternalLink,
  eye: Eye,
  eyeOff: EyeOffIcon,
  figma: Figma,
  file: File,
  fileDown: FileDown,
  fileOff: FileX2,
  filePlus: FilePlus,
  fileQuestion: FileQuestion,
  fileUp: FileUpIcon,
  folderClose: FolderClosed,
  folderOpen: FolderOpen,
  folderPlus: FolderPlus,
  ghost: Ghost,
  github: GithubIcon,
  gitlab: GitlabIcon,
  globe: Globe,
  googleWorkspace: Google,
  graduationCap: GraduationCap,
  gridVertical: GridVertical,
  headset: Headset,
  history: History,
  house: House,
  hyperbrowser: Hyperbrowser,
  image: Image,
  imageOff: ImageOff,
  imageUp: ImageUp,
  infinity: InfinityIcon,
  info: InfoIcon,
  intercom: Intercom,
  intercomChat: IntercomChat,
  jira: Jira,
  key: KeyRound,
  lab: FlaskConical,
  letterText: LetterText,
  lightBulb: Lightbulb,
  linear: Linear,
  link: Link2,
  listCheck: ListCheck,
  listOrdered: ListOrdered,
  listTodo: ListTodo,
  listVideo: ListVideo,
  loader: LoaderCircle,
  lock: Lock,
  logo: LatitudeLogo,
  logoMonochrome: LatitudeLogoMonochrome,
  logOut: LogOut,
  logs: Logs,
  mail: Mail,
  mapPin: MapPin,
  maximize: Maximize2,
  mcp: MCP,
  messageCircle: MessageCircle,
  minimize: Minimize2,
  mintlify: Mintlify,
  minus: MinusIcon,
  modification: SquareDot,
  monitor: MonitorIcon,
  moon: Moon,
  neon: Neon,
  newspaper: Newspaper,
  notEqual: EqualNotIcon,
  notion: Notion,
  paperclip: Paperclip,
  pause: Pause,
  pencil: Pencil,
  pin: Pin,
  pinOff: PinOff,
  play: Play,
  circlePlay: CirclePlayIcon,
  postgres: Postgres,
  puzzle: Puzzle,
  radio: Radio,
  readwise: Readwise,
  reddit: Reddit,
  redis: Redis,
  refresh: RefreshCcw,
  regex: RegexIcon,
  repeat: Repeat2,
  rollText: ScrollTextIcon,
  rotate: RotateCcw,
  search: SearchIcon,
  sentry: Sentry,
  settings: SettingsIcon,
  slack: SlackIcon,
  sparkles: Sparkles,
  square: Square,
  squareArrowRight: SquareArrowRight,
  squareDashed: SquareDashed,
  star: Star,
  stripe: Stripe,
  sun: Sun,
  supabase: Supabase,
  sendToBack: SendToBack,
  telegram: Telegram,
  terminal: Terminal,
  text: Type,
  thermometer: Thermometer,
  thumbsDown: ThumbsDown,
  thumbsUp: ThumbsUp,
  tinybird: Tinybird,
  trash: Trash2Icon,
  twitter: TwitterIcon,
  twitterX: TwitterX,
  undo: Undo,
  unplug: Unplug,
  userRound: UserRound,
  userRoundPlus: UserRoundPlus,
  video: Video,
  wholeWord: WholeWord,
  wordpress: Wordpress,
  youtube: YoutubeIcon,
  space: Space,
  blend: Blend,
  plus: PlusIcon,
  exa: Exa,
  yepcode: YepCode,
  monday: Monday,
  gitCompareArrows: GitCompareArrows,
  aLargeSmall: ALargeSmallIcon,
  openai: OpenAI,
  anthropic: Anthropic,
  groq: Groq,
  mistral: Mistral,
  azure: Azure,
  googleGemini: GoogleGemini,
  googleVertex: GoogleVertex,
  xai: XAI,
  amazonBedrock: AmazonBedrock,
  deepSeek: DeepSeek,
  perplexity: Perplexity,
  zap: Zap,
  creditCard: CreditCardIcon,
  chartNoAxesGantt: ChartNoAxesGantt,
  rectangleHorizontal: RectangleHorizontal,
  expand: Expand,
  forward: Forward,
  circleGauge: CircleGauge,
  users: UsersIcon,
  coins: CoinsIcon,
  rocket: RocketIcon,
  gift: GiftIcon,
  accessibility: Accessibility,
  wrench: Wrench,
  mousePointerClick: MousePointerClick,
  filledBadgeCheck: FilledBadgeCheckIcon,
  baseline: BaselineIcon,
  percent: PercentIcon,
  sigma: SigmaIcon,
  wandSparkles: WandSparkles,
  cornerDownRight: CornerDownRightIcon,
  split: Split,
}

export type IconName = keyof typeof Icons

export type IconProps = {
  name: IconName
  color?: TextColor
  darkColor?: DarkTextColor
  spin?: boolean
  spinSpeed?: 'normal' | 'fast'
  size?: Size
  widthClass?: string
  heightClass?: string
  className?: string
  onClick?: (event: MouseEvent<SVGSVGElement>) => void
  strokeWidth?: number
}

type Size =
  | 'xsmall'
  | 'small'
  | 'xnormal'
  | 'normal'
  | 'medium'
  | 'large'
  | 'xlarge'
  | 'xxxlarge'

export function Icon({
  name,
  color,
  darkColor,
  spin,
  spinSpeed = 'normal',
  size = 'normal',
  strokeWidth = 2,
  className,
  onClick,
}: IconProps) {
  const IconClass = Icons[name]!
  return (
    <IconClass
      className={cn(
        {
          [colors.textColors[color!]]: color,
          [colors.darkTextColors[darkColor!]]: darkColor,
          'w-2.5 h-2.5': size === 'xsmall',
          'w-3 h-3': size === 'small',
          'w-3.5 h-3.5': size === 'xnormal',
          'w-4 h-4': size === 'normal',
          'w-5 h-5': size === 'medium',
          'w-6 h-6': size === 'large',
          'w-8 h-8': size === 'xlarge',
          'w-14 h-14': size === 'xxxlarge',
          'animate-spin': spin,
          'duration-200': spinSpeed === 'fast',
        },
        className,
      )}
      onClick={onClick}
      strokeWidth={strokeWidth}
    />
  )
}
